/** dataId 비교 시 문자열로 통일 (API 숫자/문자 혼용 대비) */
export function idKey(id) {
    return String(id);
}

/** 현재 목록 항목이 chkedData에 모두 포함됐는지 (전체 선택 상태) */
export function isFullListSelected(monitData, chkedData) {
    const allIdNos = (monitData ?? []).map((el) => el.dataId);

    if (allIdNos.length === 0 || !Array.isArray(chkedData) || chkedData.length === 0) {
        return false;
    }

    const selectedKeys = new Set(chkedData.map(idKey));

    return allIdNos.every((id) => selectedKeys.has(idKey(id)));
}
